module.exports = __webpack_public_path__ + "static/img/bofang.4d586b6a.png";